import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import styles from '../styles/Assistant.module.css';

const Assistant = () => {
  useEffect(() => {
    // 确保iframe加载后视口正确设置
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      meta.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      );
    }
  }, []);

  return (
    <Box className={styles.container}>
      <iframe
        title="AI Assistant"
        src="https://qa-agent.ddigiai.net/chat/RFxrUsOlmuwTW81O"
        className={styles.iframe}
        scrolling="no"
        allow="clipboard-write"
      />
    </Box>
  );
};

export default Assistant;
